module.exports = __webpack_public_path__ + "images/patterns/light/DotsChecker.c64ade9b1931e459fe77.svg";